import classNames from 'classnames';
import moment from 'moment';
import React from 'react';

import {omit} from 'util/omitKey';

import {Timer} from '../timers/TimerTypes';

interface Props {
  timer: Timer;
  onRequestPlayAudio: () => void;
  onRequestPauseAudio: () => void;
}

class ToolboxActiveTimer extends React.Component<Props> {
  interval?: NodeJS.Timeout;
  override componentDidMount(): void {
    this.interval = setInterval(this.forceUpdate.bind(this), 30);
  }

  override componentWillUnmount(): void {
    clearInterval(this.interval);
    this.props.onRequestPauseAudio();
  }

  secondsLeft = (): number => {
    if (!this.props.timer.startMoment) {
      return 0;
    }
    const msElapsed = moment().diff(this.props.timer.startMoment);
    return Math.max(0, (this.props.timer.startMS - msElapsed) / 1000);
  };

  override componentDidUpdate(): void {
    if (this.secondsLeft() > 0 || this.props.timer.inlineCopy) {
      this.props.onRequestPauseAudio();
    } else {
      // Out of time.
      this.props.onRequestPlayAudio();
    }
  }

  override render(): JSX.Element {
    function pad(val: number): string {
      if (val < 10) {
        return `0${val}`;
      } else {
        return `${val}`;
      }
    }
    const secondsLeft = this.secondsLeft();
    let minutes = Math.floor(secondsLeft / 60);
    const seconds = Math.floor(secondsLeft % 60);
    const hours = Math.floor(minutes / 60);
    minutes %= 60;
    return (
      <div
        {...{
          ...omit(this.props, 'timer', 'onRequestPlayAudio', 'onRequestPauseAudio'),
          className: classNames({
            'toolbox-timer-display': true,
            ticking: secondsLeft === 0,
          }),
          title: 'Next timer sets off in...',
        }}
      >
        {`${pad(hours)}:${pad(minutes)}:${pad(seconds)}`}
      </div>
    );
  }
}

export default ToolboxActiveTimer;
